import { v4 as uuidv4 } from 'uuid'

export class DistributorItemDto {
    
    public readonly alreadyMapped: boolean = false;
    public readonly suggestedSku: string | null;
    public readonly distributorCode: string | null;
    public readonly distributorSku: string | null;
    public readonly brand: string | null;
    public readonly styleCode: string | null;
    public readonly partId: string | null;
    public readonly color: string | null;
    public readonly colorCode: string | null;
    public readonly sizeCode: string | null;
    private id: string = uuidv4();

    constructor(distributorCode: string, distributorSku: string, brand: string | null, styleCode: string | null,
                partId: string | null, color: string | null, colorCode: string | null, sizeCode: string | null,
                suggestedSku: string | null, alreadyMapped: boolean) {
        this.distributorCode = distributorCode;
        this.distributorSku = distributorSku;
        this.brand = brand;
        this.styleCode = styleCode;
        this.partId = partId;
        this.color = color;
        this.colorCode = colorCode;
        this.sizeCode = sizeCode;
        this.suggestedSku = suggestedSku;
        this.alreadyMapped = alreadyMapped;
    }

    public getId(): string {
        return this.id;
    }
}
